import React from 'react';

import Avatar from '@atlaskit/avatar';

export default (): React.JSX.Element => <Avatar size="medium" testId="avatar" />;
